'use client'

import CreationToolStep from 'creation/src/creation-tools/types/steps'
import { usePathname } from 'next/navigation'

/**
 * Ported from legacy hooks/use-creation-next-step.ts and manager.tsx's
 * currentStep derivation.
 *
 * Legacy matched a step's route as a substring of the pathname. That broke
 * down once the GIF Maker's base path ('/create/gifmaker') itself contained
 * the Create step's own route ('/create'): '/create/gifmaker/finalize'
 * matched Create before it ever tested '/finalize'. Match the route as a
 * trailing path segment instead, so a route only matches the end of the
 * pathname, not any substring of it.
 */
const matchesStep = (pathname: string, step: CreationToolStep): boolean => {
    const route = CreationToolStep.route(step)
    // Trailing slashes are tolerated because Next's pathname may or may not
    // carry one.
    return pathname.replace(/\/$/, '').endsWith(route)
}

export const useCurrentStep = (steps: CreationToolStep[]): CreationToolStep | undefined => {
    const pathname = usePathname()
    return steps.find((step) => matchesStep(pathname, step))
}

export const useCreationNextStep = (steps: CreationToolStep[]): CreationToolStep | undefined => {
    const pathname = usePathname()
    const current = steps.find((step) => matchesStep(pathname, step))
    if (!current) {
        return undefined
    }
    return steps[steps.indexOf(current) + 1]
}
